import React from 'react';
import styled from '@emotion/styled';

const CheckboxRoot = styled.div`
  width: 18px;
  height: 18px;
  border: 2px solid rgba(var(--al-primary-rgb), 0.5);
  border-radius: 2px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
  background: ${(props) => (props.$checked ? 'var(--al-primary)' : 'transparent')};
  border-color: ${(props) => (props.$checked ? 'var(--al-primary)' : 'rgba(var(--al-primary-rgb), 0.5)')};
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};

  &:hover {
    border-color: ${(props) => !props.$disabled && 'var(--al-primary)'};
  }

  svg {
    width: 14px;
    height: 14px;
    fill: #222;
    opacity: ${(props) => (props.$checked ? 1 : 0)};
  }
`;

const IndeterminateMark = styled.div`
  width: 10px;
  height: 2px;
  background: #222;
  border-radius: 1px;
`;

function OrderingCheckbox({ checked, indeterminate = false, disabled = false, onToggle, ...rest }) {
  const handleClick = (e) => {
    e.stopPropagation();
    if (!disabled && onToggle) onToggle();
  };

  return (
    <CheckboxRoot
      role="checkbox"
      aria-checked={indeterminate ? 'mixed' : checked}
      $checked={checked && !indeterminate}
      $disabled={disabled}
      onClick={handleClick}
      {...rest}
    >
      {indeterminate ? (
        <IndeterminateMark />
      ) : (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
        </svg>
      )}
    </CheckboxRoot>
  );
}

export default OrderingCheckbox;
